import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  from: Yup.object().shape({
    material: Yup.object().shape({}).required('Material is required.'),
    quantity: Yup.number().positive().required('Weight is required.'),
  }),
  effectiveDate: Yup.string().nullable().required('Effective Date is required.'),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
